import { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface IScrollToTopProps {
    children: React.ReactElement;
}

const ScrollToTop = ({ children }: IScrollToTopProps): JSX.Element => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return children;
};

export default ScrollToTop;
